import React from 'react'
import { StyledTradingUpCard } from './TWStaticTradingUpCard.styled'

export const TWStaticTradingUpCard = () => {
    const promo = require('./images/promo.jpg')

    return (
        <StyledTradingUpCard>
            <img
                src={promo}
                alt="Trading Up - Episodes drop afternoons Monday to Friday"
                role=""
            />
        </StyledTradingUpCard>
    )
}
